import { KopfFussDataResponse } from '@/types/service-response'

export class ProjectReprintHeaderFooterText {
  public constructor (
    readonly id: number,
    readonly kopfText: string,
    readonly fussText: string
  ) {}

  static createFromResponse (responseData: KopfFussDataResponse): ProjectReprintHeaderFooterText {
    return new ProjectReprintHeaderFooterText(
      responseData.ID,
      responseData.KopfText ? responseData.KopfText : '',
      responseData.FussText ? responseData.FussText : ''
    )
  }
}
